import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-title',
  styleUrl: 'lilu-title.scss',
  shadow: true,
})
export class LiluTitle {

  @Prop() textAlign = 'left';
  @Prop() appearance?: string;
  @Prop() maintitle: string;
  @Prop() subtitle: string;

  render() {
    return (
      <Host>
        <div class={`title ${this.textAlign} ${this.appearance ? this.appearance : ''}`}>
          <lilu-heading color="nero" level="2">{this.maintitle}</lilu-heading>
          <lilu-heading color="nero" level="3">{this.subtitle}</lilu-heading>
        </div>
      </Host>
    );
  }
}
